// SQLite schema for the offline engine — DERIVED ARTIFACT.
//
// Source of truth: PHP / prod MariaDB. The offline DB replicates the
// prod schema for the tables the offline engine queries. Both the
// CREATE TABLE and CREATE INDEX statements below are regenerated by
// hitting the API endpoint and writing the response back here:
//
//   curl https://api.geekgroup.app/api/offline/schema_js > app/src/offline/schema.js
//
// (Server-side: \Offline\Schema introspects the live prod schema via
// SHOW CREATE TABLE / SHOW INDEXES and translates MariaDB types to
// SQLite affinities.)
//
// THIS FILE IS ONLY USED BY THE LEGACY JSON SNAPSHOT IMPORT PATH. The
// new .sqlite snapshot path (Sync.snapshotSqlite) generates its DDL
// inline at snapshot time directly from the prod schema, so its schema
// is always in sync without needing this file regenerated.
//
// Type conventions:
// - Every table uses INTEGER PRIMARY KEY (no AUTOINCREMENT) since IDs
//   come from the server.
// - JSON fields stored as TEXT.
// - Dates stored as INTEGER (unix timestamps).

export const SCHEMA_VERSION = 5

export const TABLES = `

-- Core user data
CREATE TABLE IF NOT EXISTS user (
	user_id INTEGER PRIMARY KEY,
	user_status INTEGER DEFAULT 0,
	user_syncing INTEGER DEFAULT 0,
	user_upgrade INTEGER DEFAULT 0,
	user_name TEXT,
	user_password TEXT,
	user_source INTEGER DEFAULT 0,
	user_date_created INTEGER,
	user_date_registered INTEGER,
	user_date_bgg INTEGER,
	user_date_sync INTEGER,
	user_date_login INTEGER,
	user_date_upgrade INTEGER,
	user_date_play_first INTEGER,
	user_date_sync_first INTEGER,
	user_date_sync_deep INTEGER,
	user_date_sync_standard INTEGER,
	user_date_sync_full INTEGER,
	user_date_sync_added INTEGER,
	user_date_notifications INTEGER,
	user_date_patreon INTEGER,
	user_date_avatar INTEGER,
	user_firstname TEXT,
	user_lastname TEXT,
	user_sortname TEXT,
	user_country INTEGER DEFAULT 0,
	user_avatar TEXT,
	user_patreon TEXT,
	user_count_collection INTEGER DEFAULT 0,
	user_count_collection_games INTEGER DEFAULT 0,
	user_count_collection_expansions INTEGER DEFAULT 0,
	user_count_ratings INTEGER DEFAULT 0,
	user_count_plays INTEGER DEFAULT 0,
	user_count_plays_games INTEGER DEFAULT 0,
	user_count_lists INTEGER DEFAULT 0,
	user_count_groups INTEGER DEFAULT 0,
	user_count_buddies INTEGER DEFAULT 0,
	user_count_hindex_added INTEGER DEFAULT 0,
	user_verification_key TEXT,
	user_hindex INTEGER DEFAULT 0,
	user_sync_type INTEGER DEFAULT 0,
	user_sync_day INTEGER DEFAULT 0,
	user_sync_time INTEGER DEFAULT 0,
	user_sync_zone TEXT,
	user_data_queue INTEGER DEFAULT 0,
	user_data_version INTEGER DEFAULT 0,
	user_perks TEXT
);

-- Games reference data
CREATE TABLE IF NOT EXISTS game (
	game_id INTEGER PRIMARY KEY,
	game_ignore INTEGER DEFAULT 0,
	game_sync INTEGER DEFAULT 0,
	game_sync_date INTEGER,
	game_type INTEGER DEFAULT 0,
	game_name TEXT,
	game_sortname TEXT,
	game_avatar TEXT,
	game_players_min INTEGER DEFAULT 0,
	game_players_max INTEGER DEFAULT 0,
	game_players_count INTEGER DEFAULT 0,
	game_players_community TEXT,
	game_players_best TEXT,
	game_players_recommended TEXT,
	game_language_count INTEGER DEFAULT 0,
	game_language_dependency INTEGER DEFAULT 0,
	game_language_votes TEXT,
	game_age_official INTEGER DEFAULT 0,
	game_age_community INTEGER DEFAULT 0,
	game_age_count INTEGER DEFAULT 0,
	game_age_votes TEXT,
	game_time_min INTEGER DEFAULT 0,
	game_time_max INTEGER DEFAULT 0,
	game_rating_avg REAL DEFAULT 0,
	game_rating_count INTEGER DEFAULT 0,
	game_weight_avg REAL DEFAULT 0,
	game_weight_count INTEGER DEFAULT 0,
	game_description TEXT,
	game_published INTEGER DEFAULT 0,
	game_rank INTEGER DEFAULT 0,
	game_color TEXT,
	game_poll_weight INTEGER DEFAULT 0,
	game_poll_language INTEGER DEFAULT 0,
	game_poll_count INTEGER DEFAULT 0,
	game_base TEXT,
	game_date_avatar INTEGER,
	game_worth_value REAL DEFAULT 0,
	game_worth_date INTEGER,
	game_worth_count INTEGER DEFAULT 0,
	game_worth_type INTEGER DEFAULT 0,
	game_own INTEGER DEFAULT 0,
	game_contains TEXT
);

CREATE TABLE IF NOT EXISTS game_version (
	game_version_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	game_version_name TEXT,
	game_version_localised TEXT,
	game_version_sort TEXT,
	game_version_avatar TEXT,
	game_version_year INTEGER DEFAULT 0,
	game_version_date_avatar INTEGER,
	game_version_storage_width REAL DEFAULT 0,
	game_version_storage_length REAL DEFAULT 0,
	game_version_storage_depth REAL DEFAULT 0,
	game_version_storage_weight REAL DEFAULT 0,
	game_version_worth_value REAL DEFAULT 0,
	game_version_worth_date INTEGER,
	game_version_worth_count INTEGER DEFAULT 0,
	game_version_worth_type INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS game_relation (
	game_relation_id INTEGER PRIMARY KEY,
	game_relation_parent INTEGER,
	game_relation_child INTEGER
);

-- Game attribute join tables
CREATE TABLE IF NOT EXISTS game_designer (
	game_designer_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	designer_id INTEGER
);

CREATE TABLE IF NOT EXISTS game_publisher (
	game_publisher_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	game_version_id INTEGER DEFAULT 0,
	publisher_id INTEGER,
	game_publisher_primary INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS game_mechanic (
	game_mechanic_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	mechanic_id INTEGER
);

CREATE TABLE IF NOT EXISTS game_category (
	game_category_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	category_id INTEGER
);

CREATE TABLE IF NOT EXISTS game_family (
	game_family_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	family_id INTEGER
);

CREATE TABLE IF NOT EXISTS game_artist (
	game_artist_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	artist_id INTEGER
);

CREATE TABLE IF NOT EXISTS game_language (
	game_language_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	game_version_id INTEGER DEFAULT 0,
	language_id INTEGER
);

CREATE TABLE IF NOT EXISTS game_subdomain (
	game_subdomain_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	subdomain_id INTEGER
);

-- Lookup tables
CREATE TABLE IF NOT EXISTS designer (
	designer_id INTEGER PRIMARY KEY,
	designer_name TEXT
);

CREATE TABLE IF NOT EXISTS publisher (
	publisher_id INTEGER PRIMARY KEY,
	publisher_name TEXT
);

CREATE TABLE IF NOT EXISTS artist (
	artist_id INTEGER PRIMARY KEY,
	artist_name TEXT
);

CREATE TABLE IF NOT EXISTS mechanic (
	mechanic_id INTEGER PRIMARY KEY,
	mechanic_name TEXT
);

CREATE TABLE IF NOT EXISTS category (
	category_id INTEGER PRIMARY KEY,
	category_name TEXT
);

CREATE TABLE IF NOT EXISTS family (
	family_id INTEGER PRIMARY KEY,
	family_name TEXT
);

CREATE TABLE IF NOT EXISTS language (
	language_id INTEGER PRIMARY KEY,
	language_name TEXT
);

CREATE TABLE IF NOT EXISTS subdomain (
	subdomain_id INTEGER PRIMARY KEY,
	subdomain_name TEXT
);

-- Collection (user+game junction)
CREATE TABLE IF NOT EXISTS collection (
	collection_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	game_id INTEGER,
	game_version_id INTEGER DEFAULT 0,
	collection_date_updated INTEGER,
	collection_date_owned INTEGER,
	collection_date_acquired INTEGER,
	collection_expansion INTEGER DEFAULT 0,
	collection_nested INTEGER DEFAULT 0,
	collection_nested_official INTEGER DEFAULT 0,
	collection_nested_custom INTEGER DEFAULT 0,
	collection_own INTEGER DEFAULT 0,
	collection_prevowned INTEGER DEFAULT 0,
	collection_fortrade INTEGER DEFAULT 0,
	collection_want INTEGER DEFAULT 0,
	collection_wanttoplay INTEGER DEFAULT 0,
	collection_wanttobuy INTEGER DEFAULT 0,
	collection_wishlist INTEGER DEFAULT 0,
	collection_preordered INTEGER DEFAULT 0,
	collection_hasparts INTEGER DEFAULT 0,
	collection_wantparts INTEGER DEFAULT 0,
	collection_hasparts_text TEXT,
	collection_wantparts_text TEXT,
	collection_condition_text TEXT,
	collection_plays INTEGER DEFAULT 0,
	collection_rating REAL DEFAULT 0,
	collection_wishlist_priority INTEGER DEFAULT 0,
	collection_wishlist_comment TEXT,
	collection_value REAL DEFAULT 0,
	collection_private_location TEXT
);

-- Plays
CREATE TABLE IF NOT EXISTS play (
	play_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	user_id INTEGER,
	play_date INTEGER,
	play_location TEXT,
	play_length INTEGER DEFAULT 0,
	play_players INTEGER DEFAULT 0,
	play_count INTEGER DEFAULT 1,
	play_result INTEGER DEFAULT 0,
	play_won INTEGER DEFAULT 0,
	play_comment TEXT,
	play_incomplete INTEGER DEFAULT 0,
	play_expansion INTEGER DEFAULT 0
);

-- Players (per-play participants)
CREATE TABLE IF NOT EXISTS player (
	player_id INTEGER PRIMARY KEY,
	play_id INTEGER,
	user_id INTEGER DEFAULT 0,
	player_name TEXT,
	player_username TEXT,
	player_start INTEGER DEFAULT 0,
	player_color TEXT,
	player_score TEXT,
	player_new INTEGER DEFAULT 0,
	player_rating TEXT,
	player_win INTEGER DEFAULT 0
);

-- Ratings
CREATE TABLE IF NOT EXISTS rating (
	rating_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	game_version_id INTEGER DEFAULT 0,
	user_id INTEGER,
	rating_date INTEGER,
	rating_value REAL DEFAULT 0
);

-- Comments
CREATE TABLE IF NOT EXISTS comment (
	comment_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	user_id INTEGER,
	comment_date INTEGER,
	comment_text TEXT
);

-- Tags
CREATE TABLE IF NOT EXISTS tag (
	tag_id INTEGER PRIMARY KEY,
	user_id INTEGER DEFAULT 0,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	family_id INTEGER DEFAULT 0,
	tag_context INTEGER DEFAULT 0,
	tag_public INTEGER DEFAULT 0,
	tag_text TEXT,
	tag_colour TEXT,
	tag_fore TEXT,
	tag_attachments INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS tag_attach (
	tag_attach_id INTEGER PRIMARY KEY,
	tag_id INTEGER,
	family_id INTEGER DEFAULT 0,
	user_id INTEGER DEFAULT 0,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	game_id INTEGER DEFAULT 0,
	collection_id INTEGER DEFAULT 0,
	rating_id INTEGER DEFAULT 0,
	play_id INTEGER DEFAULT 0,
	tag_attach_date INTEGER
);

CREATE TABLE IF NOT EXISTS tag_family (
	family_id INTEGER PRIMARY KEY,
	user_id INTEGER DEFAULT 0,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	family_type INTEGER DEFAULT 0,
	family_context INTEGER DEFAULT 0,
	family_public INTEGER DEFAULT 0,
	family_style INTEGER DEFAULT 0,
	family_colour TEXT,
	family_fore TEXT,
	family_name TEXT,
	family_attachments INTEGER DEFAULT 0
);

-- Lists
CREATE TABLE IF NOT EXISTS list (
	list_id INTEGER PRIMARY KEY,
	group_id INTEGER DEFAULT 0,
	user_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	list_public INTEGER DEFAULT 0,
	list_ready INTEGER DEFAULT 0,
	list_slug TEXT,
	list_template INTEGER DEFAULT 0,
	list_date_create INTEGER,
	list_date_start INTEGER,
	list_date_update INTEGER,
	list_type INTEGER DEFAULT 0,
	list_frequency INTEGER DEFAULT 0,
	list_ranked INTEGER DEFAULT 0,
	list_name TEXT,
	list_description TEXT,
	list_filter TEXT,
	list_columns TEXT,
	list_count_editions INTEGER DEFAULT 0,
	list_count_progress INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS list_edition (
	list_edition_id INTEGER PRIMARY KEY,
	list_id INTEGER,
	list_edition_current INTEGER DEFAULT 0,
	list_edition_name TEXT,
	list_edition_slug TEXT,
	list_edition_date INTEGER,
	list_edition_date_generated INTEGER,
	list_edition_count_games INTEGER DEFAULT 0,
	list_edition_index_games TEXT
);

-- Groups
CREATE TABLE IF NOT EXISTS groups (
	group_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	group_type INTEGER DEFAULT 0,
	group_membership INTEGER DEFAULT 0,
	group_avatar TEXT,
	group_name TEXT,
	group_slug TEXT,
	group_oldslug TEXT,
	group_date_created INTEGER,
	group_date_play_first INTEGER,
	group_count_users INTEGER DEFAULT 0,
	group_count_sync INTEGER DEFAULT 0,
	group_count_collection INTEGER DEFAULT 0,
	group_count_collection_games INTEGER DEFAULT 0,
	group_count_collection_expansions INTEGER DEFAULT 0,
	group_count_ratings INTEGER DEFAULT 0,
	group_count_plays INTEGER DEFAULT 0,
	group_count_plays_games INTEGER DEFAULT 0,
	group_count_lists INTEGER DEFAULT 0,
	group_count_daily INTEGER DEFAULT 0,
	group_count_daily_self INTEGER DEFAULT 0,
	group_count_daily_perk INTEGER DEFAULT 0,
	group_count_weekly INTEGER DEFAULT 0,
	group_data_queue INTEGER DEFAULT 0,
	group_data_version INTEGER DEFAULT 0
);

-- Buddies
CREATE TABLE IF NOT EXISTS buddies (
	buddies_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	buddies_name TEXT,
	buddies_slug TEXT,
	buddies_avatar TEXT,
	buddies_date_created INTEGER,
	buddies_date_sync INTEGER,
	buddies_date_play_first INTEGER,
	buddies_count_users INTEGER DEFAULT 0,
	buddies_count_sync INTEGER DEFAULT 0,
	buddies_count_collection INTEGER DEFAULT 0,
	buddies_count_collection_games INTEGER DEFAULT 0,
	buddies_count_collection_expansions INTEGER DEFAULT 0,
	buddies_count_ratings INTEGER DEFAULT 0,
	buddies_count_plays INTEGER DEFAULT 0,
	buddies_count_plays_games INTEGER DEFAULT 0,
	buddies_count_lists INTEGER DEFAULT 0,
	buddies_data_queue INTEGER DEFAULT 0,
	buddies_data_version INTEGER DEFAULT 0
);

-- Link tables (group members, buddy members)
CREATE TABLE IF NOT EXISTS link_group_user (
	link_id INTEGER PRIMARY KEY,
	group_id INTEGER,
	user_id INTEGER,
	link_order INTEGER DEFAULT 0,
	daily_self INTEGER DEFAULT 0,
	daily_perk INTEGER DEFAULT 0,
	weekly INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS link_buddies_user (
	link_id INTEGER PRIMARY KEY,
	buddies_id INTEGER,
	user_id INTEGER,
	link_order INTEGER DEFAULT 0
);

-- H-index tracking
CREATE TABLE IF NOT EXISTS hindex_type (
	hindex_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	hindex_official INTEGER DEFAULT 0,
	hindex_public INTEGER DEFAULT 0,
	hindex_name TEXT,
	hindex_slug TEXT,
	hindex_description TEXT,
	hindex_author TEXT,
	hindex_filter TEXT,
	hindex_users INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS hindex_track (
	track_id INTEGER PRIMARY KEY,
	hindex_id INTEGER,
	user_id INTEGER,
	track_generated INTEGER,
	track_hindex INTEGER DEFAULT 0,
	track_concentration REAL DEFAULT 0,
	track_bias REAL DEFAULT 0,
	track_share REAL DEFAULT 0,
	track_coverage REAL DEFAULT 0,
	track_efficiency REAL DEFAULT 0,
	track_plays INTEGER DEFAULT 0
);

-- Server-precomputed community hindex distribution per (level, field).
-- Replaces the offline engine's previous in-snapshot copy of every
-- log_user_hindex row (~535k rows, 220MB on power users) — slim
-- payloads now ship only the rows for the user's active hindex levels.
-- See api/fuel/app/classes/insights/hindex/levels.php for usage.
CREATE TABLE IF NOT EXISTS insight_community_hindex (
	insight_community_hindex_id INTEGER PRIMARY KEY,
	insight_community_hindex_date INTEGER DEFAULT 0,
	insight_community_hindex_stamp TEXT DEFAULT '',
	hindex_id INTEGER,
	hindex_level INTEGER,
	field TEXT,
	count_total INTEGER DEFAULT 0,
	count_positive INTEGER DEFAULT 0,
	median_total REAL DEFAULT 0,
	median_positive REAL DEFAULT 0,
	min_v REAL DEFAULT 0,
	max_v REAL DEFAULT 0,
	bin_counts TEXT,
	bin_edges TEXT,
	cdf TEXT
);

-- Custom overrides
CREATE TABLE IF NOT EXISTS custom_rename (
	custom_rename_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	game_id INTEGER,
	collection_id INTEGER DEFAULT 0,
	custom_rename_text TEXT,
	custom_rename_public INTEGER DEFAULT 0,
	custom_rename_context INTEGER DEFAULT 0
);

-- User config
CREATE TABLE IF NOT EXISTS config (
	config_id INTEGER PRIMARY KEY,
	user_id INTEGER DEFAULT 0,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	session_id TEXT,
	config_data TEXT
);

-- Saved filter presets
CREATE TABLE IF NOT EXISTS preset (
	preset_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	preset_type INTEGER DEFAULT 0,
	preset_name TEXT,
	preset_filter TEXT,
	preset_default INTEGER DEFAULT 0
);

-- Custom views (field configurations)
CREATE TABLE IF NOT EXISTS view (
	view_id INTEGER PRIMARY KEY,
	user_id INTEGER DEFAULT 0,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	view_default INTEGER DEFAULT 0,
	view_type INTEGER DEFAULT 0,
	view_context INTEGER DEFAULT 0,
	view_public INTEGER DEFAULT 0,
	view_name TEXT,
	view_slug TEXT,
	view_fields TEXT
);

-- Notifications
CREATE TABLE IF NOT EXISTS notification (
	notification_id INTEGER PRIMARY KEY,
	user_id INTEGER DEFAULT 0,
	notification_date INTEGER,
	notification_type INTEGER DEFAULT 0,
	notification_title TEXT,
	notification_content TEXT,
	notification_data TEXT,
	notification_link TEXT,
	notification_image TEXT,
	notification_prompt INTEGER DEFAULT 0
);

-- Exchange rates
CREATE TABLE IF NOT EXISTS exchange (
	exchange_id INTEGER PRIMARY KEY,
	exchange_date INTEGER,
	exchange_gbp REAL DEFAULT 0,
	exchange_cad REAL DEFAULT 0,
	exchange_aud REAL DEFAULT 0,
	exchange_eur REAL DEFAULT 0,
	exchange_brl REAL DEFAULT 0,
	exchange_cny REAL DEFAULT 0,
	exchange_jpy REAL DEFAULT 0,
	exchange_bgn REAL DEFAULT 0
);

-- Generic content/settings
CREATE TABLE IF NOT EXISTS generic_settings (
	setting_id INTEGER PRIMARY KEY,
	setting_name TEXT,
	setting_value TEXT
);

CREATE TABLE IF NOT EXISTS devlog (
	devlog_id INTEGER PRIMARY KEY,
	devlog_date INTEGER,
	devlog_type INTEGER DEFAULT 0,
	devlog_name TEXT,
	devlog_slug TEXT,
	devlog_content TEXT,
	devlog_count_features INTEGER DEFAULT 0,
	devlog_count_fixes INTEGER DEFAULT 0,
	devlog_url TEXT,
	devlog_image TEXT
);

-- Platform/perk state
CREATE TABLE IF NOT EXISTS platform_subdomain (
	subdomain_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	subdomain_date INTEGER,
	subdomain_status INTEGER DEFAULT 0,
	subdomain_type INTEGER DEFAULT 0,
	subdomain_recipient INTEGER DEFAULT 0,
	subdomain_value TEXT
);

CREATE TABLE IF NOT EXISTS platform_externaldomain (
	externaldomain_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	externaldomain_date INTEGER,
	externaldomain_status INTEGER DEFAULT 0,
	externaldomain_type INTEGER DEFAULT 0,
	externaldomain_recipient INTEGER DEFAULT 0,
	externaldomain_value TEXT
);

CREATE TABLE IF NOT EXISTS platform_early (
	early_id INTEGER PRIMARY KEY,
	early_status INTEGER DEFAULT 0,
	early_name TEXT,
	early_slug TEXT,
	early_description TEXT,
	early_date_added TEXT,
	early_date_live TEXT,
	early_image TEXT,
	early_url TEXT,
	early_adopted TEXT
);

CREATE TABLE IF NOT EXISTS platform_syncs (
	syncs_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	syncs_date INTEGER,
	syncs_status INTEGER DEFAULT 0,
	syncs_type INTEGER DEFAULT 0,
	syncs_recipient INTEGER DEFAULT 0,
	syncs_value TEXT
);

CREATE TABLE IF NOT EXISTS platform_boost (
	boost_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	boost_date INTEGER,
	boost_status INTEGER DEFAULT 0,
	boost_type INTEGER DEFAULT 0,
	boost_recipient INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS platform_voting_feature (
	feature_id INTEGER PRIMARY KEY,
	feature_name TEXT,
	feature_description TEXT,
	feature_status INTEGER DEFAULT 0,
	feature_date_added INTEGER,
	feature_date_won INTEGER,
	feature_date_removed INTEGER
);

CREATE TABLE IF NOT EXISTS platform_voting_vote (
	vote_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	feature_id INTEGER,
	vote_date INTEGER,
	vote_count INTEGER DEFAULT 0,
	vote_stamp TEXT
);

-- Log tables (needed for insights and activity feeds)
CREATE TABLE IF NOT EXISTS log_user_collection (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	game_id INTEGER,
	game_version_id INTEGER DEFAULT 0,
	collection_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0,
	log_size INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_collection_status (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	game_id INTEGER,
	game_version_id INTEGER DEFAULT 0,
	collection_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0,
	log_status TEXT,
	log_value INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_play (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	game_id INTEGER,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0,
	log_count INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_rating (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	game_id INTEGER,
	log_context INTEGER DEFAULT 0,
	log_rating REAL DEFAULT 0,
	log_previous REAL DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_hindex (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	play_id INTEGER DEFAULT 0,
	game_id INTEGER DEFAULT 0,
	hindex_id INTEGER DEFAULT 0,
	log_hindex INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0,
	log_plays_level INTEGER DEFAULT 0,
	log_plays_all INTEGER DEFAULT 0,
	log_games_level INTEGER DEFAULT 0,
	log_games_new INTEGER DEFAULT 0,
	log_games_all INTEGER DEFAULT 0,
	log_days INTEGER DEFAULT 0,
	log_efficiency_current REAL DEFAULT 0,
	log_efficiency_next REAL DEFAULT 0,
	log_index_level TEXT,
	log_index_played TEXT
);

CREATE TABLE IF NOT EXISTS log_user_comment (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	game_id INTEGER,
	log_context INTEGER DEFAULT 0,
	log_comment TEXT,
	log_previous TEXT,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_tag (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	tag_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0,
	log_tag_context INTEGER DEFAULT 0,
	log_tag_text TEXT,
	log_tag_colour TEXT
);

CREATE TABLE IF NOT EXISTS log_user_tag_attach (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	tag_id INTEGER DEFAULT 0,
	tag_attach_id INTEGER DEFAULT 0,
	game_id INTEGER DEFAULT 0,
	collection_id INTEGER DEFAULT 0,
	rating_id INTEGER DEFAULT 0,
	play_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0,
	log_tag_context INTEGER DEFAULT 0,
	log_tag_text TEXT,
	log_tag_colour TEXT
);

CREATE TABLE IF NOT EXISTS log_user_group (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	group_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_member (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	group_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_buddy (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	buddies_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_buddies (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	buddies_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_listing (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	list_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_list_name TEXT,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_edition (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	group_id INTEGER DEFAULT 0,
	buddies_id INTEGER DEFAULT 0,
	list_id INTEGER DEFAULT 0,
	list_edition_id INTEGER DEFAULT 0,
	log_context INTEGER DEFAULT 0,
	log_list_name TEXT,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_initiated (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	log_initial_sync INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS log_user_registered (
	log_id INTEGER PRIMARY KEY,
	log_date INTEGER,
	user_id INTEGER,
	log_initial_sync INTEGER DEFAULT 0
);

-- Insight snapshots
CREATE TABLE IF NOT EXISTS insight (
	insight_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	group_id INTEGER,
	buddies_id INTEGER,
	insight_type INTEGER,
	insight_date INTEGER,
	insight_stamp TEXT,
	insight_period INTEGER,
	insight_value INTEGER
);

CREATE TABLE IF NOT EXISTS insight_user_collection (
	insight_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	insight_date INTEGER,
	insight_stamp TEXT,
	insight_games TEXT,
	insight_added TEXT,
	insight_removed TEXT,
	insight_count INTEGER,
	insight_count_base INTEGER,
	insight_count_expansions INTEGER,
	insight_count_added INTEGER,
	insight_count_removed INTEGER,
	insight_count_base_added INTEGER DEFAULT 0,
	insight_count_base_removed INTEGER DEFAULT 0,
	insight_count_valued INTEGER,
	insight_value REAL,
	insight_value_base REAL,
	insight_value_expansions REAL
);

CREATE TABLE IF NOT EXISTS insight_user_games (
	insight_id INTEGER PRIMARY KEY,
	user_id INTEGER,
	insight_date INTEGER,
	insight_stamp TEXT,
	insight_games TEXT,
	insight_total INTEGER DEFAULT 0,
	insight_owned INTEGER DEFAULT 0,
	insight_played INTEGER DEFAULT 0,
	insight_rated INTEGER DEFAULT 0,
	insight_wishlist INTEGER,
	insight_bubble INTEGER DEFAULT 0,
	insight_stale INTEGER DEFAULT 0,
	insight_prevowned INTEGER
);

CREATE TABLE IF NOT EXISTS insight_game (
	insight_game_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	insight_game_stamp TEXT,
	insight_game_date INTEGER DEFAULT 0,
	insight_game_owners INTEGER DEFAULT 0,
	insight_game_prevowners INTEGER DEFAULT 0,
	insight_game_wishlisted INTEGER DEFAULT 0,
	insight_game_raters INTEGER DEFAULT 0,
	insight_game_players INTEGER DEFAULT 0,
	insight_game_total_plays INTEGER DEFAULT 0,
	insight_game_avg_rating REAL DEFAULT 0,
	insight_game_avg_plays REAL DEFAULT 0,
	insight_game_retention REAL DEFAULT 0,
	insight_game_rank INTEGER DEFAULT 0,
	insight_game_weight REAL DEFAULT 0,
	insight_game_bgg_rating REAL DEFAULT 0,
	insight_game_owners_added INTEGER DEFAULT 0,
	insight_game_owners_removed INTEGER DEFAULT 0,
	insight_game_wish_added INTEGER DEFAULT 0,
	insight_game_wish_removed INTEGER DEFAULT 0,
	insight_game_wtp_added INTEGER DEFAULT 0,
	insight_game_wtp_removed INTEGER DEFAULT 0,
	insight_game_plays_month INTEGER DEFAULT 0,
	insight_game_sessions_month INTEGER DEFAULT 0,
	insight_game_players_new INTEGER DEFAULT 0,
	insight_game_hours_month REAL DEFAULT 0,
	insight_game_ratings_added INTEGER DEFAULT 0,
	insight_game_ratings_changed INTEGER DEFAULT 0,
	insight_game_ratings_removed INTEGER DEFAULT 0,
	insight_game_data TEXT
);

CREATE TABLE IF NOT EXISTS insight_game_value (
	insight_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	insight_date INTEGER,
	insight_stamp TEXT,
	insight_value REAL DEFAULT 0,
	insight_value_count INTEGER DEFAULT 0,
	insight_value_type INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS insight_game_version_value (
	insight_id INTEGER PRIMARY KEY,
	game_id INTEGER,
	game_version_id INTEGER,
	insight_date INTEGER,
	insight_stamp TEXT,
	insight_value REAL,
	insight_value_count INTEGER,
	insight_value_type INTEGER
);

-- Local search cache (mirrors Model\\Search pattern)
CREATE TABLE IF NOT EXISTS search (
	search_id INTEGER PRIMARY KEY AUTOINCREMENT,
	search_type INTEGER DEFAULT 0,
	search_key TEXT,
	search_filter TEXT,
	search_config TEXT,
	search_total INTEGER DEFAULT 0,
	search_total_max INTEGER DEFAULT 0,
	search_total_pseudo INTEGER DEFAULT 0,
	search_total_nested INTEGER DEFAULT 0,
	search_index TEXT,
	search_games TEXT,
	search_users TEXT,
	search_nested TEXT,
	search_data_id INTEGER DEFAULT 0,
	search_data_session INTEGER DEFAULT 0,
	search_data_api TEXT,
	search_data_type INTEGER DEFAULT 0,
	search_data_version INTEGER,
	search_usage INTEGER DEFAULT 0,
	search_duration INTEGER DEFAULT 0,
	search_date INTEGER
);

-- Offline metadata (sync state, schema version, etc.)
CREATE TABLE IF NOT EXISTS _offline_meta (
	key TEXT PRIMARY KEY,
	value TEXT
);

`

export const INDEXES = `

-- Collection indexes
CREATE INDEX IF NOT EXISTS idx_collection_user ON collection(user_id);
CREATE INDEX IF NOT EXISTS idx_collection_game ON collection(game_id);
CREATE INDEX IF NOT EXISTS idx_collection_user_game ON collection(user_id, game_id);
CREATE INDEX IF NOT EXISTS idx_collection_own ON collection(collection_own);

-- Play indexes
CREATE INDEX IF NOT EXISTS idx_play_user ON play(user_id);
CREATE INDEX IF NOT EXISTS idx_play_game ON play(game_id);
CREATE INDEX IF NOT EXISTS idx_play_user_game ON play(user_id, game_id);
CREATE INDEX IF NOT EXISTS idx_play_date ON play(play_date);

-- Rating indexes
CREATE INDEX IF NOT EXISTS idx_rating_user ON rating(user_id);
CREATE INDEX IF NOT EXISTS idx_rating_game ON rating(game_id);
CREATE INDEX IF NOT EXISTS idx_rating_user_game ON rating(user_id, game_id);

-- Player indexes
CREATE INDEX IF NOT EXISTS idx_player_play ON player(play_id);
CREATE INDEX IF NOT EXISTS idx_player_user ON player(user_id);

-- Comment indexes
CREATE INDEX IF NOT EXISTS idx_comment_user ON comment(user_id);
CREATE INDEX IF NOT EXISTS idx_comment_game ON comment(game_id);

-- Search indexes
CREATE INDEX IF NOT EXISTS idx_search_key ON search(search_key);
CREATE INDEX IF NOT EXISTS idx_search_owner ON search(search_data_type, search_data_id, search_data_version);

-- Game relation indexes
CREATE INDEX IF NOT EXISTS idx_game_designer_game ON game_designer(game_id);
CREATE INDEX IF NOT EXISTS idx_game_designer_designer ON game_designer(designer_id);
CREATE INDEX IF NOT EXISTS idx_game_publisher_game ON game_publisher(game_id);
CREATE INDEX IF NOT EXISTS idx_game_publisher_publisher ON game_publisher(publisher_id);
CREATE INDEX IF NOT EXISTS idx_game_mechanic_game ON game_mechanic(game_id);
CREATE INDEX IF NOT EXISTS idx_game_mechanic_mechanic ON game_mechanic(mechanic_id);
CREATE INDEX IF NOT EXISTS idx_game_category_game ON game_category(game_id);
CREATE INDEX IF NOT EXISTS idx_game_category_category ON game_category(category_id);
CREATE INDEX IF NOT EXISTS idx_game_family_game ON game_family(game_id);
CREATE INDEX IF NOT EXISTS idx_game_family_family ON game_family(family_id);
CREATE INDEX IF NOT EXISTS idx_game_artist_game ON game_artist(game_id);
CREATE INDEX IF NOT EXISTS idx_game_artist_artist ON game_artist(artist_id);
CREATE INDEX IF NOT EXISTS idx_game_language_game ON game_language(game_id);
CREATE INDEX IF NOT EXISTS idx_game_language_language ON game_language(language_id);
CREATE INDEX IF NOT EXISTS idx_game_subdomain_game ON game_subdomain(game_id);
CREATE INDEX IF NOT EXISTS idx_game_subdomain_subdomain ON game_subdomain(subdomain_id);
CREATE INDEX IF NOT EXISTS idx_game_version_game ON game_version(game_id);
CREATE INDEX IF NOT EXISTS idx_game_relation_parent ON game_relation(game_relation_parent);
CREATE INDEX IF NOT EXISTS idx_game_relation_child ON game_relation(game_relation_child);

-- Tag indexes
CREATE INDEX IF NOT EXISTS idx_tag_user ON tag(user_id);
CREATE INDEX IF NOT EXISTS idx_tag_group ON tag(group_id);
CREATE INDEX IF NOT EXISTS idx_tag_buddies ON tag(buddies_id);
CREATE INDEX IF NOT EXISTS idx_tag_attach_tag ON tag_attach(tag_id);
CREATE INDEX IF NOT EXISTS idx_tag_attach_game ON tag_attach(game_id);
CREATE INDEX IF NOT EXISTS idx_tag_attach_collection ON tag_attach(collection_id);
CREATE INDEX IF NOT EXISTS idx_tag_attach_play ON tag_attach(play_id);
CREATE INDEX IF NOT EXISTS idx_tag_attach_rating ON tag_attach(rating_id);

-- Link indexes
CREATE INDEX IF NOT EXISTS idx_link_group_user_group ON link_group_user(group_id);
CREATE INDEX IF NOT EXISTS idx_link_group_user_user ON link_group_user(user_id);
CREATE INDEX IF NOT EXISTS idx_link_buddies_user_buddies ON link_buddies_user(buddies_id);
CREATE INDEX IF NOT EXISTS idx_link_buddies_user_user ON link_buddies_user(user_id);

-- List indexes
CREATE INDEX IF NOT EXISTS idx_list_user ON list(user_id);
CREATE INDEX IF NOT EXISTS idx_list_group ON list(group_id);
CREATE INDEX IF NOT EXISTS idx_list_buddies ON list(buddies_id);
CREATE INDEX IF NOT EXISTS idx_list_edition_list ON list_edition(list_id);

-- Log indexes
CREATE INDEX IF NOT EXISTS idx_log_collection_user ON log_user_collection(user_id);
CREATE INDEX IF NOT EXISTS idx_log_collection_game ON log_user_collection(game_id);
CREATE INDEX IF NOT EXISTS idx_log_collection_date ON log_user_collection(log_date);
CREATE INDEX IF NOT EXISTS idx_log_play_user ON log_user_play(user_id);
CREATE INDEX IF NOT EXISTS idx_log_play_game ON log_user_play(game_id);
CREATE INDEX IF NOT EXISTS idx_log_play_date ON log_user_play(log_date);
CREATE INDEX IF NOT EXISTS idx_log_rating_user ON log_user_rating(user_id);
CREATE INDEX IF NOT EXISTS idx_log_rating_game ON log_user_rating(game_id);
CREATE INDEX IF NOT EXISTS idx_log_rating_date ON log_user_rating(log_date);
CREATE INDEX IF NOT EXISTS idx_log_hindex_user ON log_user_hindex(user_id);
CREATE INDEX IF NOT EXISTS idx_log_hindex_date ON log_user_hindex(log_date);
CREATE INDEX IF NOT EXISTS idx_log_group_user ON log_user_group(user_id);
CREATE INDEX IF NOT EXISTS idx_log_member_user ON log_user_member(user_id);
CREATE INDEX IF NOT EXISTS idx_log_buddy_user ON log_user_buddy(user_id);
CREATE INDEX IF NOT EXISTS idx_log_buddies_user ON log_user_buddies(user_id);
CREATE INDEX IF NOT EXISTS idx_log_listing_user ON log_user_listing(user_id);
CREATE INDEX IF NOT EXISTS idx_log_edition_user ON log_user_edition(user_id);

-- H-index indexes
CREATE INDEX IF NOT EXISTS idx_hindex_type_user ON hindex_type(user_id);
CREATE INDEX IF NOT EXISTS idx_hindex_type_slug ON hindex_type(hindex_slug);
CREATE INDEX IF NOT EXISTS idx_hindex_track_user ON hindex_track(user_id);
CREATE INDEX IF NOT EXISTS idx_hindex_track_hindex ON hindex_track(hindex_id);

-- Custom rename indexes
CREATE INDEX IF NOT EXISTS idx_custom_rename_user_game ON custom_rename(user_id, game_id);

-- Preset indexes
CREATE INDEX IF NOT EXISTS idx_preset_user ON preset(user_id);

-- View indexes
CREATE INDEX IF NOT EXISTS idx_view_user ON view(user_id);
CREATE INDEX IF NOT EXISTS idx_view_group ON view(group_id);

-- Insight game value indexes
CREATE INDEX IF NOT EXISTS idx_insight_user ON insight(user_id);
CREATE INDEX IF NOT EXISTS idx_insight_group ON insight(group_id);
CREATE INDEX IF NOT EXISTS idx_insight_buddies ON insight(buddies_id);
CREATE INDEX IF NOT EXISTS idx_insight_type ON insight(insight_type);
CREATE INDEX IF NOT EXISTS idx_insight_stamp ON insight(insight_stamp);
CREATE INDEX IF NOT EXISTS idx_insight_uc_user ON insight_user_collection(user_id);
CREATE INDEX IF NOT EXISTS idx_insight_uc_stamp ON insight_user_collection(insight_stamp);
CREATE INDEX IF NOT EXISTS idx_insight_ug_user ON insight_user_games(user_id);
CREATE INDEX IF NOT EXISTS idx_insight_ug_stamp ON insight_user_games(insight_stamp);
CREATE INDEX IF NOT EXISTS idx_insight_game_value_game ON insight_game_value(game_id);
CREATE INDEX IF NOT EXISTS idx_insight_game_value_date ON insight_game_value(insight_date);
CREATE INDEX IF NOT EXISTS idx_insight_gvv_game ON insight_game_version_value(game_id);
CREATE INDEX IF NOT EXISTS idx_insight_gvv_version ON insight_game_version_value(game_version_id);
CREATE INDEX IF NOT EXISTS idx_insight_gvv_date ON insight_game_version_value(insight_date);

-- Search cache indexes
CREATE INDEX IF NOT EXISTS idx_search_owner ON search(search_owner_type, search_owner_id, search_data_version);

-- Game indexes for filter engine
CREATE INDEX IF NOT EXISTS idx_game_type ON game(game_type);
CREATE INDEX IF NOT EXISTS idx_game_sortname ON game(game_sortname);
CREATE INDEX IF NOT EXISTS idx_game_rank ON game(game_rank);

`
